import { render, staticRenderFns } from "./StepFiles.vue?vue&type=template&id=1ec65b6a&"
import script from "./StepFiles.vue?vue&type=script&lang=js&"
export * from "./StepFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec65b6a')) {
      api.createRecord('1ec65b6a', component.options)
    } else {
      api.reload('1ec65b6a', component.options)
    }
    module.hot.accept("./StepFiles.vue?vue&type=template&id=1ec65b6a&", function () {
      api.rerender('1ec65b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepFiles.vue"
export default component.exports